<template>
  <section class="price-list card">
    <h3 class="title">{{ $t('product_pricing_table') }}</h3>
    <template v-for="item in props.product.price_list" :key="item.name">
      <div class="flex justify-between items-top gap-3 py-4">
        <span>{{ item.name }}</span>
        <i18n-t class="flex gap-1" tag="span" keypath="my_favorites_product_card_price">
          <template #currency>
            <span>{{ props.product?.currency_code }}</span>
          </template>
          <template #price>
            <span v-price="item.total_price"></span>
          </template>
        </i18n-t>
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()
</script>

<style lang="scss" scoped></style>
